import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProductCard from '../../components/base/ProductCard';
import Button from '../../components/base/Button';

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const bannerSlides = [
    {
      id: 1,
      title: "办公用品 限时特惠",
      subtitle: "精选优质办公用品，提升工作效率",
      image: "https://readdy.ai/api/search-image?query=Modern%20office%20supplies%20and%20stationery%20on%20clean%20white%20desk%2C%20professional%20workspace%20setup%20with%20notebooks%2C%20pens%2C%20folders%2C%20bright%20lighting%2C%20minimalist%20business%20style%2C%20high%20quality%20product%20photography&width=1200&height=400&seq=banner1&orientation=landscape",
      cta: "立即选购"
    },
    {
      id: 2,
      title: "摄影器材 专业品质",
      subtitle: "专业摄影设备，记录美好瞬间",
      image: "https://readdy.ai/api/search-image?query=Professional%20photography%20equipment%20including%20cameras%2C%20lenses%2C%20tripods%20on%20clean%20white%20background%2C%20modern%20studio%20setup%2C%20elegant%20product%20display%2C%20bright%20lighting%2C%20minimalist%20style&width=1200&height=400&seq=banner2&orientation=landscape",
      cta: "查看详情"
    },
    {
      id: 3,
      title: "电子产品 科技前沿",
      subtitle: "最新电子设备，引领科技潮流",
      image: "https://readdy.ai/api/search-image?query=Modern%20electronic%20devices%20and%20gadgets%20on%20clean%20white%20background%2C%20smartphones%2C%20tablets%2C%20laptops%2C%20professional%20tech%20product%20photography%2C%20sleek%20design%2C%20minimalist%20style&width=1200&height=400&seq=banner3&orientation=landscape",
      cta: "立即购买"
    }
  ];

  const featuredProducts = [
    {
      id: "1",
      name: "多功能办公桌垫",
      price: 89.9,
      originalPrice: 129.9,
      image: "https://readdy.ai/api/search-image?query=Premium%20office%20desk%20mat%20with%20multiple%20functions%2C%20clean%20white%20background%2C%20professional%20office%20accessory%20photography%2C%20modern%20workspace%20essential%2C%20elegant%20design%2C%20minimalist%20style&width=300&height=300&seq=deskmat1&orientation=squarish",
      description: "防水防滑，超大尺寸，提升办公体验",
      tags: ["防水防滑", "包邮", "品质保证"]
    },
    {
      id: "2",
      name: "人体工学办公椅",
      price: 599.0,
      originalPrice: 799.0,
      image: "https://readdy.ai/api/search-image?query=Ergonomic%20office%20chair%20with%20modern%20design%2C%20clean%20white%20background%2C%20professional%20furniture%20photography%2C%20comfortable%20workspace%20seating%2C%20sleek%20black%20design%2C%20minimalist%20style&width=300&height=300&seq=chair1&orientation=squarish",
      description: "舒适透气，护腰设计，久坐不累",
      tags: ["人体工学", "透气网布", "护腰设计"]
    },
    {
      id: "3",
      name: "智能文件整理架",
      price: 45.8,
      image: "https://readdy.ai/api/search-image?query=Smart%20file%20organizer%20rack%20for%20office%2C%20clean%20white%20background%2C%20professional%20office%20storage%20photography%2C%20modern%20document%20organization%20system%2C%20elegant%20design%2C%20minimalist%20style&width=300&height=300&seq=organizer1&orientation=squarish",
      description: "多层分类，节省空间，办公必备",
      tags: ["多层设计", "节省空间", "办公必备"]
    },
    {
      id: "4",
      name: "无线蓝牙键盘",
      price: 168.0,
      originalPrice: 218.0,
      image: "https://readdy.ai/api/search-image?query=Wireless%20bluetooth%20keyboard%20with%20modern%20design%2C%20clean%20white%20background%2C%20professional%20tech%20accessory%20photography%2C%20sleek%20minimalist%20keyboard%2C%20elegant%20presentation&width=300&height=300&seq=keyboard1&orientation=squarish",
      description: "静音按键，长续航，提升打字体验",
      tags: ["无线连接", "静音设计", "长续航"]
    }
  ];

  const categories = [
    {
      name: "办公用品",
      icon: "ri-briefcase-line",
      image: "https://readdy.ai/api/search-image?query=Office%20supplies%20collection%20including%20pens%2C%20notebooks%2C%20folders%2C%20clean%20white%20background%2C%20professional%20stationery%20photography%2C%20modern%20workspace%20essentials%2C%20bright%20lighting%2C%20minimalist%20style&width=200&height=200&seq=cat1&orientation=squarish",
      link: "/category/office"
    },
    {
      name: "摄影器材",
      icon: "ri-camera-line",
      image: "https://readdy.ai/api/search-image?query=Photography%20equipment%20collection%20with%20cameras%20and%20lenses%2C%20clean%20white%20background%2C%20professional%20camera%20gear%20photography%2C%20modern%20photography%20tools%2C%20elegant%20presentation%2C%20minimalist%20style&width=200&height=200&seq=cat2&orientation=squarish",
      link: "/category/photography"
    },
    {
      name: "电子产品",
      icon: "ri-smartphone-line",
      image: "https://readdy.ai/api/search-image?query=Electronic%20devices%20collection%20including%20smartphones%20and%20gadgets%2C%20clean%20white%20background%2C%20professional%20tech%20product%20photography%2C%20modern%20electronics%2C%20sleek%20design%2C%20minimalist%20style&width=200&height=200&seq=cat3&orientation=squarish",
      link: "/category/electronics"
    },
    {
      name: "会议设备",
      icon: "ri-presentation-line",
      image: "https://readdy.ai/api/search-image?query=Conference%20and%20meeting%20equipment%20including%20projectors%2C%20microphones%2C%20video%20conferencing%20devices%2C%20clean%20white%20background%2C%20professional%20business%20equipment%20photography%2C%20modern%20meeting%20room%20setup%2C%20minimalist%20style&width=200&height=200&seq=cat4&orientation=squarish",
      link: "/category/conference"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % bannerSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + bannerSlides.length) % bannerSlides.length);
  };

  const handleAddToCart = (productId: string) => {
    console.log('Added to cart:', productId);
    // 这里可以添加购物车逻辑
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero Banner */}
        <section className="relative h-96 overflow-hidden">
          <div className="relative w-full h-full">
            {bannerSlides.map((slide, index) => (
              <div
                key={slide.id}
                className={`absolute inset-0 transition-opacity duration-500 ${
                  index === currentSlide ? 'opacity-100' : 'opacity-0'
                }`}
                style={{
                  backgroundImage: `url(${slide.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              >
                <div className="absolute inset-0 bg-black/30"></div>
                <div className="relative h-full flex items-center">
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                    <div className="max-w-lg">
                      <h2 className="text-4xl font-bold text-white mb-4">
                        {slide.title}
                      </h2>
                      <p className="text-xl text-white/90 mb-6">
                        {slide.subtitle}
                      </p>
                      <Button size="lg" className="bg-orange-500 hover:bg-orange-600">
                        {slide.cta}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-2 rounded-full transition-colors"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/20 hover:bg-white/30 text-white p-2 rounded-full transition-colors"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          
          {/* Dots Indicator */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {bannerSlides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  index === currentSlide ? 'bg-white' : 'bg-white/50'
                }`}
              />
            ))}
          </div>
        </section>

        {/* Categories Section */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
              商品分类
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {categories.map((category, index) => (
                <a
                  key={index}
                  href={category.link}
                  className="group bg-white rounded-lg p-6 text-center hover:shadow-lg transition-shadow duration-200 cursor-pointer"
                >
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full overflow-hidden">
                    <img
                      src={category.image}
                      alt={category.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-200"
                    />
                  </div>
                  <h3 className="font-semibold text-gray-800 group-hover:text-orange-500 transition-colors">
                    {category.name}
                  </h3>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Products */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between mb-12">
              <h2 className="text-3xl font-bold text-gray-800">
                精选商品
              </h2>
              <a href="/products" className="text-orange-500 hover:text-orange-600 font-medium">
                查看更多 <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {featuredProducts.map((product) => (
                <ProductCard
                  key={product.id}
                  {...product}
                  onAddToCart={() => handleAddToCart(product.id)}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-16 bg-orange-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
              我们的优势
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">品质保证</h3>
                <p className="text-gray-600">
                  严选优质商品，确保每一件产品都符合高标准要求
                </p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">专业服务</h3>
                <p className="text-gray-600">
                  专业客服团队，为您提供贴心的购物咨询服务
                </p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">快速配送</h3>
                <p className="text-gray-600">
                  与知名物流合作，提供快速可靠的配送服务
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
